<div class="shipment-date">
  <div *ngFor="let shipment of shipments; trackBy: trackByShipmentNumber">
    <label>Shipment {{ shipment.number }}</label>

    <mat-form-field appearance="outline" color="primary">
      <input 
          matInput 
          readonly
          placeholder="Shipment Date" 
          [genOnlyNumber]="true"
          [formControl]="shipment.dateControl"
          [matDatepicker]="picker" 
          [matDatepickerFilter]="desiredDayFilter"
      >
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  </div>
</div>